import React, { memo } from 'react'
import { FormConsumer } from '@active/react-ui/Form'
import FormGroup from '@active/react-ui/FormGroup'
import FormLabel from '@active/react-ui/FormLabel'
import FormField from '@active/react-ui/FormField'
import Input from '@active/react-ui/Input'
import Grid from '@active/react-ui/Grid'
import GridItem from '@active/react-ui/GridItem'
import Button from '@active/react-ui/Button'
import LinkButton from '@active/react-ui/LinkButton'
import { withI18n } from '@active/react-utils/i18n'
import Responsive from '@active/react-utils/components/Responsive'
import {
  bool, func, string, number, oneOfType,
} from 'prop-types'
import Form from '../../../InjectedForm'
import EmailInputWithBadListCheck from '../../../EmailInputWithBadListCheck'
import I18nMessage from '../../../I18nMessage'
import './VerifyCodeByNewEmail.scss'

function VerifyCodeByNewEmail({
  onSendCode,
  onEmailChange,
  countDownNumber,
  showSentCodeWording,
  showExistingError,
  proxyForm,
  i18n,
},
) {
  const buttonText = 'passport.common.btn.send'
  return (
    <Form className="verify-code-by-new-email-form" customizeLayout horizontal>
      <Grid container={false} rowGapLevel={0}>
        <GridItem span={12}>
          <FormGroup name="email" required>
            <Grid container={false} rowGapLevel={0}>
              <GridItem span={12} spanMd={3}>
                <FormLabel>
                  <I18nMessage id="passport.updateAccount.content.newEmailLabel" />
                </FormLabel>
              </GridItem>
              <GridItem span={12} spanMd={5}>
                <FormField
                  placeholder={i18n('passport.common.placeholder.email')}
                  onChange={onEmailChange}
                  as={EmailInputWithBadListCheck}
                  autoComplete="email"
                />
              </GridItem>
              <Responsive eqAbove="md">
                <GridItem span={2} colGap={10}>
                  <Button type="primary" onClick={onSendCode} disabled={!!countDownNumber}>{countDownNumber ? `${countDownNumber}s` : <I18nMessage id={buttonText} />}</Button>
                </GridItem>
              </Responsive>
            </Grid>
          </FormGroup>
        </GridItem>
        { showSentCodeWording && (
        <>
          <Responsive eqAbove="md" not>
            <GridItem span={12} className="sent-code-wording">
              <i className="ic-check-r" />
              <I18nMessage id="passport.updateAccount.content.sent.code.tips" />
            </GridItem>
          </Responsive>
          <Responsive eqAbove="md">
            <GridItem span={5} offset={3} className="sent-code-wording">
              <i className="ic-check-r" />
              <I18nMessage id="passport.updateAccount.content.sent.code.tips" />
            </GridItem>
          </Responsive>
        </>
        ) }
        { showExistingError && (
        <>
          <Responsive eqAbove="md" not>
            <GridItem span={12} className="email-existing-error">
              <i className="ic-cross-r" />
              <I18nMessage id="passport.updateAccount.content.emailExistError" />
            </GridItem>
          </Responsive>
          <Responsive eqAbove="md">
            <GridItem span={5} offset={3} className="email-existing-error">
              <i className="ic-cross-r" />
              <I18nMessage id="passport.updateAccount.content.emailExistError" />
            </GridItem>
          </Responsive>
        </>
        )}
        <GridItem span={12}>
          <Responsive eqAbove="md" not>
            <div className="sent-btn mg-px-t-20 mg-px-b-18">
              <LinkButton onClick={onSendCode} disabled={!!countDownNumber}>
                <I18nMessage id={buttonText} />
                {countDownNumber ? `(${countDownNumber}s)` : '' }
              </LinkButton>
            </div>
          </Responsive>
        </GridItem>
        <GridItem span={12} className="mg-px-t-20">
          <FormGroup name="code" required>
            <Grid container={false} rowGapLevel={0}>
              <GridItem span={12} spanMd={3}>
                <FormLabel>
                  <I18nMessage id="passport.verification.modal.input.placeholder" />
                </FormLabel>
              </GridItem>
              <GridItem span={12} spanMd={5}>
                <FormField
                  placeholder={i18n('passport.verification.modal.input.code.placeholder')}
                  as={Input}
                  autoComplete="one-time-code"
                />
              </GridItem>
            </Grid>
          </FormGroup>
        </GridItem>
      </Grid>
      <FormConsumer>
        {
                ({
                  form,
                }) => {
                  proxyForm(form)
                }
            }
      </FormConsumer>
    </Form>
  )
}

VerifyCodeByNewEmail.propTypes = {
  proxyForm: func.isRequired,
  countDownNumber: oneOfType([string, number]),
  onSendCode: func.isRequired,
  showSentCodeWording: bool,
  i18n: func.isRequired,
  onEmailChange: func,
  showExistingError: bool,
}
VerifyCodeByNewEmail.defaultProps = {
  countDownNumber: 0,
  showSentCodeWording: false,
  onEmailChange: undefined,
  showExistingError: false,
}
export default memo(withI18n(VerifyCodeByNewEmail))
